<template>
  <button class="navigate-main-button select-none" @click="onClick">
    <slot></slot>
  </button>
</template>

<script>
/**
 * Large white button for achievements and other single action views like the splash screen
 */
export default {
  name: "NavigateMainButton",
  methods: {
    onClick(event) {
      this.$emit("click", event);
    }
  }
};
</script>
